import { Component, Prop, Element, h } from "@stencil/core";
import { StringUtils } from "../../core/utils/StringUtils";

@Component({
    tag: "snt-blog-info",
    styleUrl: "./blog-info-component.scss",
    shadow: false
})
export class SntBlogInfo {
    @Element() hostElement: HTMLElement;
    @Prop() titleText: string;
    @Prop() blogLink: string;
    @Prop() publishedTime: string;
    @Prop() timeToRead: string;
    @Prop() accessibilityText: string;

    public static readonly TAG_NAME = "snt-blog-info";
    private ariaTextJson: any;

    componentWillLoad() {
        if (StringUtils.hasValue(this.accessibilityText)) {
            this.ariaTextJson = JSON.parse(this.accessibilityText);
        }
    }

    render() {
        return (
            <div class="spacings">
                <div id="blog-info-bar">
                    <div class="left-info">
                        <div class="schedule-info"><span class="icons-container icon-font iconCalendar"></span><p>{this.publishedTime}</p></div>
                        <div class="read-time-info"><span class="icons-container icon-font iconClock"></span><p>{this.timeToRead}</p></div>
                    </div>
                    <div class="social-icons">
                        <div><a href={`http://www.linkedin.com/shareArticle?mini=true&url=${this.blogLink}&title=${this.titleText}`} aria-label={this.ariaTextJson.linkedIn}><i class="icon-font iconLinkedin"></i></a></div>
                        <div><a href={`https://www.facebook.com/sharer/sharer.php?u=${this.blogLink}`} aria-label={this.ariaTextJson.facebook}><i class="icon-font iconFacebookPlain"></i></a></div>
                        <div><a href={`https://twitter.com/intent/tweet?url=${this.blogLink}&text=${this.titleText}`} aria-label={this.ariaTextJson.twitter}><i class="icon-font iconTwitter"></i></a></div>
                        <div><a href={`mailto:?subject=${this.titleText}&body=${this.blogLink}`} aria-label={this.ariaTextJson.email}><i class="icon-font iconMail"></i></a></div>
                    </div>
                </div>
            </div>
        );
    }
}
